"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStaticListSource = exports.useListSource = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const crud_source_hook_1 = require("./crud-source-hook");
const event_callback_hook_1 = require("./event-callback-hook");
const fetch_hook_1 = require("./fetch-hook");
function useListSource({ url, apiUrl, params, method = 'POST', skip = false, }) {
    const [result, loading, reset] = (0, fetch_hook_1.useFetch)(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: params !== undefined ? JSON.stringify(params) : undefined,
        skip,
    });
    const loadDetail = (0, event_callback_hook_1.useEventCallback)(async (item) => {
        if (apiUrl !== undefined) {
            const fetch = (0, crud_source_hook_1.defaultGetItem)(apiUrl, item.id);
            const detail = await fetch.json();
            return detail;
        }
        return Promise.resolve(item);
    });
    const source = (0, react_1.useMemo)(() => ({
        items: result !== null && result !== void 0 ? result : [],
        loading,
        reset,
        loadDetail,
    }), [loading, reset, result, loadDetail]);
    return source;
}
exports.useListSource = useListSource;
function useStaticListSource(items) {
    return {
        loading: false,
        reset: lodash_1.noop,
        loadDetail: identityPromise,
        items,
    };
}
exports.useStaticListSource = useStaticListSource;
function identityPromise(item) {
    return Promise.resolve(item);
}
//# sourceMappingURL=list-source-hook.js.map